export const countriesList = [
    { id: "AF", label: "Αφγανιστάν", value: "Afghanistan", code: "AF" },
    { id: "AL", label: "Αλβανία", value: "Albania", code: "AL" },
    { id: "DZ", label: "Αλγερία", value: "Algeria", code: "DZ" },
    { id: "AD", label: "Ανδόρα", value: "Andorra", code: "AD" },
    { id: "AO", label: "Αγκόλα", value: "Angola", code: "AO" },
    { id: "AG", label: "Αντίγκουα και Μπαρμπούδα", value: "AntiguaandBarbuda", code: "AG" },
    { id: "AR", label: "Αργεντινή", value: "Argentina", code: "AR" },
    { id: "AM", label: "Αρμενία", value: "Armenia", code: "AM" },
    { id: "AU", label: "Αυστραλία", value: "Australia", code: "AU" },
    { id: "AT", label: "Αυστρία", value: "Austria", code: "AT" },
    { id: "AZ", label: "Αζερμπαϊτζάν", value: "Azerbaijan", code: "AZ" },
    { id: "BS", label: "Μπαχάμες", value: "Bahamas", code: "BS" },
    { id: "BH", label: "Μπαχρέιν", value: "Bahrain", code: "BH" },
    { id: "BD", label: "Μπανγκλαντές", value: "Bangladesh", code: "BD" },
    { id: "BB", label: "Μπαρμπάντος", value: "Barbados", code: "BB" },
    { id: "BY", label: "Λευκορωσία", value: "Belarus", code: "BY" },
    { id: "BE", label: "Βέλγιο", value: "Belgium", code: "BE" },
    { id: "BZ", label: "Μπελίζ", value: "Belize", code: "BZ" },
    { id: "BJ", label: "Μπενίν", value: "Benin", code: "BJ" },
    { id: "BT", label: "Μπουτάν", value: "Bhutan", code: "BT" },
    { id: "BO", label: "Βολιβία", value: "Bolivia", code: "BO" },
    { id: "BA", label: "Βοσνία και Ερζεγοβίνη", value: "BosniaandHerzegovina", code: "BA" },
    { id: "BW", label: "Μποτσουάνα", value: "Botswana", code: "BW" },
    { id: "BR", label: "Βραζιλία", value: "Brazil", code: "BR" },
    { id: "BN", label: "Μπρουνέι", value: "Brunei", code: "BN" },
    { id: "BG", label: "Βουλγαρία", value: "Bulgaria", code: "BG" },
    { id: "BF", label: "Μπουρκίνα Φάσο", value: "BurkinaFaso", code: "BF" },
    { id: "BI", label: "Μπουρούντι", value: "Burundi", code: "BI" },
    { id: "CV", label: "Κάπο Βέρντε", value: "CaboVerde", code: "CV" },
    { id: "KH", label: "Καμπότζη", value: "Cambodia", code: "KH" },
    { id: "CM", label: "Καμερούν", value: "Cameroon", code: "CM" },
    { id: "CA", label: "Καναδάς", value: "Canada", code: "CA" },
    { id: "CF", label: "Κεντροαφρικανική Δημοκρατία", value: "CentralAfricanRepublic", code: "CF" },
    { id: "TD", label: "Τσαντ", value: "Chad", code: "TD" },
    { id: "CL", label: "Χιλή", value: "Chile", code: "CL" },
    { id: "CN", label: "Κίνα", value: "China", code: "CN" },
    { id: "CO", label: "Κολομβία", value: "Colombia", code: "CO" },
    { id: "KM", label: "Κομόρες", value: "Comoros", code: "KM" },
    { id: "CG", label: "Κονγκό (Κονγκό-Μπραζαβίλ)", value: "CongoBrazzaville", code: "CG" },
    { id: "CD", label: "Κονγκό (Κονγκό-Κινσάσα)", value: "CongoKinshasa", code: "CD" },
    { id: "CR", label: "Κόστα Ρίκα", value: "CostaRica", code: "CR" },
    { id: "HR", label: "Κροατία", value: "Croatia", code: "HR" },
    { id: "CU", label: "Κούβα", value: "Cuba", code: "CU" },
    { id: "CY", label: "Κύπρος", value: "Cyprus", code: "CY" },
    { id: "CZ", label: "Τσεχία (Τσεχική Δημοκρατία)", value: "Czechia", code: "CZ" },
    { id: "DK", label: "Δανία", value: "Denmark", code: "DK" },
    { id: "DJ", label: "Τζιμπουτί", value: "Djibouti", code: "DJ" },
    { id: "DM", label: "Δομινίκα", value: "Dominica", code: "DM" },
    { id: "DO", label: "Δομινικανή Δημοκρατία", value: "DominicanRepublic", code: "DO" },
    { id: "EC", label: "Εκουαδόρ", value: "Ecuador", code: "EC" },
    { id: "EG", label: "Αίγυπτος", value: "Egypt", code: "EG" },
    { id: "SV", label: "Ελ Σαλβαδόρ", value: "ElSalvador", code: "SV" },
    { id: "GQ", label: "Ισημερινή Γουινέα", value: "EquatorialGuinea", code: "GQ" },
    { id: "ER", label: "Ερυθραία", value: "Eritrea", code: "ER" },
    { id: "EE", label: "Εσθονία", value: "Estonia", code: "EE" },
    { id: "SZ", label: "Εσουατίνι", value: "Eswatini", code: "SZ" },
    { id: "ET", label: "Αιθιοπία", value: "Ethiopia", code: "ET" },
    { id: "FJ", label: "Φίτζι", value: "Fiji", code: "FJ" },
    { id: "FI", label: "Φινλανδία", value: "Finland", code: "FI" },
    { id: "FR", label: "Γαλλία", value: "France", code: "FR" },
    { id: "GA", label: "Γκαμπόν", value: "Gabon", code: "GA" },
    { id: "GM", label: "Γκάμπια", value: "Gambia", code: "GM" },
    { id: "GE", label: "Γεωργία", value: "Georgia", code: "GE" },
    { id: "DE", label: "Γερμανία", value: "Germany", code: "DE" },
    { id: "GH", label: "Γκάνα", value: "Ghana", code: "GH" },
    { id: "GR", label: "Ελλάδα", value: "Greece", code: "GR" },
    { id: "GD", label: "Γρενάδα", value: "Grenada", code: "GD" },
    { id: "GT", label: "Γουατεμάλα", value: "Guatemala", code: "GT" },
    { id: "GN", label: "Γουινέα", value: "Guinea", code: "GN" },
    { id: "GW", label: "Γουινέα-Μπισσάου", value: "GuineaBissau", code: "GW" },
    { id: "HT", label: "Αϊτή", value: "Haiti", code: "HT" },
    { id: "HN", label: "Ονδούρες", value: "Honduras", code: "HN" },
    { id: "HU", label: "Ουγγαρία", value: "Hungary", code: "HU" },
    { id: "IS", label: "Ισλανδία", value: "Iceland", code: "IS" },
    { id: "IN", label: "Ινδία", value: "India", code: "IN" },
    { id: "ID", label: "Ινδονησία", value: "Indonesia", code: "ID" },
    { id: "IR", label: "Ιράν", value: "Iran", code: "IR" },
    { id: "IQ", label: "Ιράκ", value: "Iraq", code: "IQ" },
    { id: "IE", label: "Ιρλανδία", value: "Ireland", code: "IE" },
    { id: "IL", label: "Ισραήλ", value: "Israel", code: "IL" },
    { id: "IT", label: "Ιταλία", value: "Italy", code: "IT" },
    { id: "JM", label: "Τζαμάικα", value: "Jamaica", code: "JM" },
    { id: "JP", label: "Ιαπωνία", value: "Japan", code: "JP" },
    { id: "JO", label: "Ιορδανία", value: "Jordan", code: "JO" },
    { id: "KZ", label: "Καζακστάν", value: "Kazakhstan", code: "KZ" },
    { id: "KE", label: "Κένυα", value: "Kenya", code: "KE" },
    { id: "KI", label: "Κιριμπάτι", value: "Kiribati", code: "KI" },
    { id: "KP", label: "Βόρεια Κορέα", value: "NorthKorea", code: "KP" },
    { id: "KR", label: "Νότια Κορέα", value: "SouthKorea", code: "KR" },
    { id: "KW", label: "Κουβέιτ", value: "Kuwait", code: "KW" },
    { id: "KG", label: "Κιργιστάν", value: "Kyrgyzstan", code: "KG" },
    { id: "LA", label: "Λάος", value: "Laos", code: "LA" },
    { id: "LV", label: "Λετονία", value: "Latvia", code: "LV" },
    { id: "LB", label: "Λίβανος", value: "Lebanon", code: "LB" },
    { id: "LS", label: "Λεσότο", value: "Lesotho", code: "LS" },
    { id: "LR", label: "Λιβερία", value: "Liberia", code: "LR" },
    { id: "LY", label: "Λιβύη", value: "Libya", code: "LY" },
    { id: "LI", label: "Λιχτενστάιν", value: "Liechtenstein", code: "LI" },
    { id: "LT", label: "Λιθουανία", value: "Lithuania", code: "LT" },
    { id: "LU", label: "Λουξεμβούργο", value: "Luxembourg", code: "LU" },
    { id: "N/A", label: "Άλλο", value: "Other", code: "N/A" }
];
